module.exports = __webpack_public_path__ + "img/tab_item_bg1.4a642623.png";